export default {
  data() {
    return {
      errors: {},
    };
  },
  methods: {
    validateRequired(fieldName, fieldValue, errorMessage) {
      if (!fieldValue && fieldValue !== 0) {
        this.errors[fieldName] =
          errorMessage || `${fieldName} không được để trống`;
        return false;
      }
      return true;
    },

    validateMinLength(fieldName, fieldValue, minLength, errorMessage) {
      if (fieldValue && fieldValue.length < minLength) {
        this.errors[fieldName] =
          errorMessage || `${fieldName} phải có ít nhất ${minLength} ký tự`;
        return false;
      }
      return true;
    },

    validateMaxLength(fieldName, fieldValue, maxLength, errorMessage) {
      if (fieldValue && fieldValue.length > maxLength) {
        this.errors[fieldName] =
          errorMessage || `${fieldName} không được vượt quá ${maxLength} ký tự`;
        return false;
      }
      return true;
    },

    validatePattern(fieldName, fieldValue, pattern, errorMessage) {
      if (fieldValue && !pattern.test(fieldValue)) {
        this.errors[fieldName] =
          errorMessage || `${fieldName} không đúng định dạng`;
        return false;
      }
      return true;
    },

    validateEmail(fieldName, fieldValue, errorMessage) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return this.validatePattern(
        fieldName,
        fieldValue,
        emailPattern,
        errorMessage || 'Email không đúng định dạng',
      );
    },

    validatePhone(fieldName, fieldValue, errorMessage) {
      const phonePattern = /^(0|\+84)[3|5|7|8|9][0-9]{8}$/;
      return this.validatePattern(
        fieldName,
        fieldValue,
        phonePattern,
        errorMessage || 'Số điện thoại không đúng định dạng',
      );
    },

    clearFieldError(fieldName) {
      if (this.errors[fieldName]) {
        this.$delete(this.errors, fieldName);
      }
    },

    clearAllErrors() {
      this.errors = {};
    },

    validateForm(formData) {
      this.clearAllErrors();
      let isValid = true;

      if (
        !this.validateRequired(
          'code',
          formData.code,
          'Mã tài khoản không được để trống',
        )
      ) {
        isValid = false;
      }

      if (
        !this.validateRequired(
          'name',
          formData.name,
          'Tên tài khoản không được để trống',
        )
      ) {
        isValid = false;
      }

      if (formData.phone && !this.validatePhone('phone', formData.phone)) {
        isValid = false;
      }

      return isValid;
    },
  },
};
